import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { makeGetDomain } from '../selectors/chartDomainSelector'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import BrushZoomChart from './BrushZoomChart'
import Rainbow from 'rainbowvis.js'

const gradient = new Rainbow()
gradient.setSpectrum('green', 'yellow', 'red')

const id = 'WaterSediment'

const chartStyles = datetime => ({
  bar: {
    data: {
      strokeWidth: 3,
      strokeOpacity: 1,
      fill: d => gradient.colourAt(d.value / 300 * 100)
    }
  }
})

const styles = theme => ({
  wrapperInner: {
    height: '100%'
  }
})

class WaterSedimentBarChart extends PureComponent {
  render () {
    const { data, datetime, domain, render } = this.props
    const title = 'River sediment'

    if (!arrayIsNotEmpty(data) || !render) {
      return null
    }

    return (
      <BrushZoomChart
        data={data}
        title={title}
        chartStyles={chartStyles}
        datetime={datetime}
        domain={domain}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()
  const getDomain = makeGetDomain()
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = state => {
    const data = getData(state, id, getFeaturesFromGeoJson)
    const datetime = getDatetime(state, id)

    return {
      data,
      datetime,
      domain: getDomain(state, data, datetime),
      fetching: state.data.fetching,
      render: getLayerRendered(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {}
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  withStyles(styles)(WaterSedimentBarChart)
)



// WEBPACK FOOTER //
// ./src/charts/WaterSedimentBarChart.js